module.exports = __webpack_public_path__ + "static/media/snygg.4fc299a2.mp3";